import {takeLatest} from 'redux-saga/effects';
// import * as demoActionType from '../actionType/demo.actionType';
import * as homeActionType from '../actionType/home.actionType';
import * as authActionType from '../actionType/auth.actionType';

import {homeSaga, submitContactSaga, getPublicLibrarySaga, getDSPUrlSaga} from './home.saga';
import {loginSaga, validateVoucherUidSaga, forgetPwdSaga, getCaptchaSaga} from './auth.saga';

export function* fetchDemoWatcherSag() {
    yield takeLatest(homeActionType.FETCH_HOME_DATA, homeSaga);
    yield takeLatest(homeActionType.SUBMIT_CONTACT, submitContactSaga);
    yield takeLatest(homeActionType.FETCH_PUBLIC_LIBRARIES, getPublicLibrarySaga);
    yield takeLatest(authActionType.LOGIN_ATTEMPT, loginSaga);
    yield takeLatest(authActionType.VALIDATE_VOUCHER, validateVoucherUidSaga);
    yield takeLatest(authActionType.FORGOT_PWD, forgetPwdSaga);
    yield takeLatest(homeActionType.FETCH_DSP_URL, getDSPUrlSaga);
    yield takeLatest(authActionType.GET_CAPTCHA_VALUE, getCaptchaSaga);
}
